export default "__VITE_ASSET__CubnXSwV__"